export default __webpack_public_path__ + "static/media/colorado_newimg.9058a678.png";